import { DriveItem } from '@cs-cms/types';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export interface MsGraphProps {
  fileUrl: string | undefined;
}

interface IMsGraphContext {
  msGraphProps: Partial<MsGraphProps>;
  setMsGraphProps: Dispatch<SetStateAction<Partial<MsGraphProps>>>;
  driveItem?: DriveItem;
  isDriveItemLoading: boolean;
}

export const MsGraphContext = createContext<IMsGraphContext>({
  msGraphProps: {},
  setMsGraphProps: () => {},
  isDriveItemLoading: false
});

export const useMsGraphContext = () => useContext(MsGraphContext);
